module.exports = __webpack_public_path__ + "media/images/country_flags/in-4b07b5ad33e74a87499b7a675f286a97.png";